export default __webpack_public_path__ + "static/media/014-missile.03e924ae.svg";